import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AppConfig } from '../app/app-config';


@Injectable()
export class CartserviceProvider { 
cartBage:number=0;

  constructor(public http: HttpClient, public storage: Storage, public appConfig: AppConfig) {
    console.log('Hello UserserviceProvider Provider');
  }
}  

 export class CartProduct {
public bezeichnung: string;
public productname: string;
public producttype: string;
public windowtype: string;
public typeopen: string
public windowlong: string;
public windowwide: string;
public dichtungen: string;
public dekorfarbe: string;
public dichtungen: string;
public outColorIn: string;
public outColorOut: string;
public selectedGriffe: string;
public selectedOrnament: any; 
public selectedVerglasung: any;  
public selectedKante: string;
public selectedSprossentyp: any;
public selectedSprossenmuster: any;
public selectedSprossenfarbe: any;
public selectedRahmenLinks: any;
public selectedRahmenRechts: any;
public selectedRahmenOben: any;
public selectedRahmenUnten: any;

  constructor() {
this.bezeichnung = '';
this.productname = '';
this.producttype = ''; 
this.windowtype = '';
this.typeopen = ''; 
this.windowlong = '';
this.windowwide = '';
this.dichtungen = '';
this.dekorfarbe = '';
this.dichtungen = '';
this.outColorIn = '';
this.outColorOut = '';
this.selectedGriffe = '';
this.selectedOrnament = ''; 
this.selectedVerglasung = ''; 
this.selectedKante = '';
this.selectedSprossentyp = '';
this.selectedSprossenmuster = '';
this.selectedSprossenfarbe = '';
this.selectedRahmenLinks = '';
this.selectedRahmenRechts = '';
this.selectedRahmenOben = '';
this.selectedRahmenUnten = '';
  }
}

export class Cart {
  public CartProductArray: Array<CartProduct>;
  //public total: number;
  //public totalShip: number;
}



// WEBPACK FOOTER //
// ./src/providers/cartservice.ts